//Built-in import

import * as React from "react";

import { ITicket, ITicketMessage } from "@/types/ticket";
import { Stack, alpha, Button , useTheme , useMediaQuery } from "@mui/material";
import { api, getEndpoint } from "@/api";

import ChatboxMeessages from "./messages";
import LoadingEmbraced from "../loading-embraced";
import { getUrlWithQueryParams } from "@/utils";
import { toaster } from "../toaster";
import MessageInputHandler from "./input/MessageInputHandler";
import { t } from "i18next";

interface IChatBoxProps {
  ticket: ITicket | null;
  items: ITicketMessage[];
  renderAgain?: () => void;
}

//Initial message text
const initiailMessageText = "";

const ChatBox: React.FunctionComponent<IChatBoxProps> = ({
  ticket,
  items = [],
  renderAgain,
}) => {
  //handling message text
  const [messageText, setMessageText] = React.useState(initiailMessageText);

  //Messages
  const [messages, setMessages] = React.useState<ITicketMessage[]>([]);

  //handling message method
  const handleSetMessageText = (val: string) => {
    setMessageText(val);
  };
  React.useEffect(() => {
    setMessages(items);
  }, [items]);

  //Ref of chatbox messages
  const chatboxRef = React.useRef<HTMLDivElement>(null);

  //responsiv
  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.down("lg"));
  

  //Handling messages
  const [loading, setLoading] = React.useState(false);
  const handleAddMessage = React.useCallback(
    async (message: string = messageText, attachment: File | null = null) => {
      setLoading(true);
      try {
        const formData = new FormData();
        if (message !== '') formData.append("message", message ?? "");
        if (attachment) formData.append("attachments[0]", attachment);
        const res = await api.post(
          getUrlWithQueryParams(
            getEndpoint("ticketMessages", {
              id: ticket.id,
            }),
            {
              expand: "media",
            }
          ),
          formData
        );

        setMessages((crt) => [...crt, res.data?.data?.item as ITicketMessage]);
        setMessageText(initiailMessageText);
        if (chatboxRef.current !== null) {
          setTimeout(() => {
            chatboxRef.current.scrollTop = chatboxRef.current?.scrollHeight;
          }, 500);
        }
      } catch (e) {
        toaster.error(e?.response?.data);
      } finally {
        setLoading(false);
      }
    },
    [messageText, chatboxRef]
  );

  const Chats = React.useMemo(() => <ChatboxMeessages ref={chatboxRef} items={messages} />, [messages])

  return (
    <>
      <Stack
        sx={{
          border: 1,
          borderColor: (t) => alpha(t.palette.common.black, 0.12),
          borderRadius: 2,
          overflow: "hidden",
          height: "auto",
        }}
      >
        {Chats}
        {!loading && <MessageInputHandler
          messageText={messageText}
          handleSetMessageText={handleSetMessageText}
          addMessage={handleAddMessage}
        />}
        {loading && <LoadingEmbraced />}
      </Stack>
    </>
  );
};

export default ChatBox;
